<template>
  <div class="card">
    <div class="card-header" id="headingAlert">
      <h5>General</h5>
      <button type="submit" form="edit-alert-form" class="btn btn-hub-primary">
        Save
      </button>
      <button type="reset" form="edit-alert-form" class="btn btn-secondary">
        Reset
      </button>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-8">
            <ValidationForm id="edit-alert-form" :onSubmit="submit" :onReset="reset">
              <div class="form-row">
                <div class="form-group col-md-4">
                  <label for="txtGeneralName">Name</label>
                  <input type="text" class="form-control" id="txtGeneralName" placeholder="Name of the event"
                    v-model="alert.name" />
                </div>
                <div class="form-group col-md-8">
                  <label for="txtDescription">Description</label>
                  <input type="text" class="form-control" id="txtDescription"
                    placeholder="A friendly description of the event" v-model="alert.description" />
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="ddlDevice">Device</label>
                  <select id="ddlDevice" class="form-control" v-model="alert.device_id">
                    <option value="null">None</option>
                    <option v-for="device in filtered_devices" :key="device.device_id" v-bind:value="device.device_id">
                      {{ device.name }}
                    </option>
                  </select>
                  <small class="form-text text-muted">Only relevant if you have a Barionet device.</small>
                </div>
                <div class="form-group col-md-6" v-if="alert.device_id !== null">
                  <label for="txtInputNumber">Input</label>
                  <input type="text" class="form-control" id="txtInputNumber" v-model="alert.input_number" />
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="ddlAlertActionType">Action Type</label>
                  <select class="form-control" id="ddlAlertActionType" v-model="alert.alert_action_type_id">
                    <option value="0">Select..</option>
                    <option v-for="alert_action_type in filtered_alert_action_types"
                      :key="alert_action_type.alert_action_type_id" v-bind:value="alert_action_type.alert_action_type_id">
                      {{ alert_action_type.name }}
                    </option>
                  </select>
                </div>
                <ValidationField
                  id="txtExtension"
                  label="Extension"
                  helperText="Not required, but can only play from web interface if left at
                    9. If inputted, must keep leading 9 and follow with 3 numbers.
                    Example: 9001"
                  v-model="alert.extension"
                  :validator="validate"
                ></ValidationField>
              </div>
            </ValidationForm>
          </div>
          <div class="col-4">
            <CurrentExtensions default_type="alert"></CurrentExtensions>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CurrentExtensions from '../CurrentExtensions.vue'
import ValidationMixin from '../../mixins/ValidationMixin.vue'
import { AlertExtensionValidator } from '../../assets/js/validators'
import { DEVICE_TYPE } from '../../assets/js/resource-types'

export default {
  props: { alert_id: { type: [Number, String] } },
  components: { CurrentExtensions },
  mixins: [ValidationMixin],
  computed: {
    ...mapGetters({
      alert: 'singleAlert',
      devices: 'allDevices',
      alert_action_types: 'allAlertActionTypes',
      scoped_site_id: 'scopedSiteId'
    }),
    filtered_devices: function () {
      return this.devices.filter(
        (device) =>
          device.device_type_id === DEVICE_TYPE.Barionet && device.site_id === this.scoped_site_id
      )
    },
    filtered_alert_action_types: function () {
      return this.alert_action_types.filter(
        (alertActionType) => alertActionType.alert_action_type_id !== 2
      )
    }
  },
  created() {
    this.$store.dispatch('setDisabledChangeScopedSite', true)
    this.$store.dispatch('getAlert', this.alert_id)
    this.$store.dispatch('getDevices')
    this.$store.dispatch('getAlertActionTypes')
  },
  updated() {
    if(!this.initial_alert_extension && this.alert) this.initial_alert_extension = this.alert.extension
  },
  methods: {
    validate(value) {
      const validator = new AlertExtensionValidator(this.extensions_in_use, this.initial_alert_extension)
      return validator.validate(value)
    },
    submit() {
      console.log("submitting")
      this.$store.dispatch('addEditAlert', { alert: this.alert })
    },
    reset() {
      this.$store.dispatch('getAlert', this.alert_id)
    }
  }
}
</script>

<style scoped>

</style>
